import { Link } from "react-router-dom";
import { ArrowDownToLine, ArrowUpFromLine, BarChart3, CalendarClock, Landmark, Scale, Settings2, Wallet } from "lucide-react";
import { defineModuleUi, useOrg } from "@vixio/data";
import { formatMoney, lazyPage } from "@vixio/ui";
import { ReceivablesPage, useReceivableKpis } from "./ReceivablesPage";

export * from "./api";
export { SettleDialog, NewReceivableDialog } from "./dialogs";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const ReceivablePage = lazyPage(() => import("./ReceivablePage"), "ReceivablePage");
const PayablesPage = lazyPage(() => import("./PayablesPage"), "PayablesPage");
const ReconciliationPage = lazyPage(() => import("./ReconciliationPage"), "ReconciliationPage");
const AgingPage = lazyPage(() => import("./ReportsPage"), "AgingPage");
const CashFlowPage = lazyPage(() => import("./ReportsPage"), "CashFlowPage");
const DrePage = lazyPage(() => import("./ReportsPage"), "DrePage");
const FinanceSettingsPage = lazyPage(() => import("./SettingsPage"), "FinanceSettingsPage");

function ReceivablesWidget() {
  const org = useOrg();
  const k = useReceivableKpis(org.id).data;
  return (
    <dl className="vx-dl">
      <dt>Vencido</dt>
      <dd className={(k?.overdue ?? 0) > 0 ? "num text-crit" : "num"}>
        {formatMoney(k?.overdue ?? 0)} <span className="muted">({k?.overdueCount ?? 0})</span>
      </dd>
      <dt>Vence em 30 dias</dt>
      <dd className="num">{formatMoney(k?.next30 ?? 0)}</dd>
      <dt>Recebido no mês</dt>
      <dd className="num">{formatMoney(k?.receivedMonth ?? 0)}</dd>
      <dt />
      <dd>
        <Link to="/dinheiro/receber">Abrir contas a receber</Link>
      </dd>
    </dl>
  );
}

export default defineModuleUi({
  key: "finance",
  title: "Financeiro",
  domain: "money",
  icon: Wallet,
  menu: [
    { path: "/dinheiro/receber", label: "A receber", minRole: "manager", icon: ArrowDownToLine, order: 10, keywords: "recebíveis parcelas recebimento estorno" },
    { path: "/dinheiro/pagar", label: "A pagar", minRole: "manager", icon: ArrowUpFromLine, order: 20, keywords: "fornecedores pagamento" },
    { path: "/dinheiro/caixa", label: "Fluxo de caixa", minRole: "manager", icon: CalendarClock, order: 30 },
    { path: "/dinheiro/conciliacao", label: "Conciliação", minRole: "manager", icon: Landmark, order: 40, keywords: "extrato ofx csv banco" },
    { path: "/dinheiro/aging", label: "Aging", minRole: "manager", icon: Scale, order: 45, keywords: "inadimplência atraso" },
    { path: "/dinheiro/dre", label: "DRE", minRole: "manager", icon: BarChart3, order: 90, keywords: "resultado demonstrativo margem" },
    { path: "/dinheiro/configuracoes", label: "Contas e categorias", minRole: "manager", icon: Settings2, order: 99, keywords: "conta bancária categoria política multa juros" },
  ],
  routes: [
    { path: "/dinheiro/receber", element: <ReceivablesPage />, minRole: "manager" },
    { path: "/dinheiro/receber/:id", element: <ReceivablePage />, minRole: "manager" },
    { path: "/dinheiro/pagar", element: <PayablesPage />, minRole: "manager" },
    { path: "/dinheiro/caixa", element: <CashFlowPage />, minRole: "manager" },
    { path: "/dinheiro/conciliacao", element: <ReconciliationPage />, minRole: "manager" },
    { path: "/dinheiro/aging", element: <AgingPage />, minRole: "manager" },
    { path: "/dinheiro/dre", element: <DrePage />, minRole: "manager" },
    { path: "/dinheiro/configuracoes", element: <FinanceSettingsPage />, minRole: "manager" },
  ],
  widgets: [{ key: "finance.receivables", title: "A receber", minRole: "manager", span: 1, order: 20, element: ReceivablesWidget }],
});
